import {Box, Grid, Typography} from '@mui/material';
import {TFunction} from 'i18next';
import BottomBar from '../BottomBar';

export default function InstructionsStep({
  activeStep,
  instructions,
  onBack,
  onNext,
  t,
  totalSteps
}: {
  activeStep: number;
  instructions: {
    title: string;
    description: string;
    image: string;
  }[];
  onBack: () => void;
  onNext: () => void;
  t: TFunction;
  totalSteps: number;
}) {
  return (
    <>
      <Grid container spacing={2}>
        {instructions.map((instruction) => (
          <Grid
            key={instruction.title}
            size={{
              xs: 12,
              sm: 6,
              md: 4
            }}
          >
            <Typography variant="h3" align="center" sx={{mb: 2}}>
              {instruction.title}
            </Typography>
            <Box
              sx={{
                height: {
                  md: 200,
                  lg: 300
                },
                mx: 4,
                '& > img': {
                  display: 'block',
                  width: {
                    xs: '100%',
                    lg: 'auto'
                  },
                  height: {
                    xs: 'auto',
                    lg: '100%'
                  },
                  mx: 'auto',
                  mb: {
                    xs: 2,
                    lg: 0
                  },
                  borderRadius: '8px',
                  objectFit: 'contain'
                }
              }}
            >
              <img src={instruction.image} alt={instruction.title} />
            </Box>
            <Box
              sx={{
                m: {
                  xs: 0,
                  lg: 2
                }
              }}
            >
              <Typography
                align="left"
                sx={{
                  mb: '16px'
                }}
              >
                {instruction.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
      <BottomBar
        isBackEnabled
        isNextEnabled
        onNext={onNext}
        t={t}
        onBack={onBack}
        activeStep={activeStep}
        totalSteps={totalSteps}
      />
    </>
  );
}
